import AdvanceSearchFormInfo from './components/AdvanceSearchFormInfo';
import Calendar from './components/Calendar';
import FormInfo from './components/FormInfo';
import OrganizationTree from './components/OrganizationTree';
import Tabs from './components/Tabs';

module.exports = {
    AdvanceSearchFormInfo,
    Calendar,
    FormInfo,
    OrganizationTree,
    Tabs,
}


// WEBPACK FOOTER //
// ../src4js/pc4backstage/hrmComsPublic/index.js